import { call, put, takeEvery } from 'redux-saga/effects'
import { types } from '../../types'
import { addWebsite, checkWebsite, getDomainGuidScriptRequest, getWebsite, removeWebsite, updateDomainAddress, updateStatusWebsite } from '../apiRequests/domainRequests'

function* handleGetDomain(action) {
  try {

    const user = JSON.parse(localStorage.getItem("sipOnlineUser"))
    const response = yield call(getWebsite, action.params ? action.params : user.userId)

    yield put({
      type: types.GET_DOMAIN_SUCCESS,
      action: response,
    })
  } catch (error) {

    yield put({
      type: types.GET_DOMAIN_ERROR,
      error: error.response,
    })
  }
}

function* handleCheckDomain(action) {
  try {

    const response = yield call(checkWebsite, action.params)

    yield put({
      type: types.CHECK_DOMAIN_SUCCESS,
      action: response,
    })
  } catch (error) {

    yield put({
      type: types.CHECK_DOMAIN_ERROR,
      error: error.response,
    })
  }
}

function* handleAddDomain(action) {

  try {
    const response = yield call(addWebsite, action.params)

    yield put({
      type: types.ADD_DOMAIN_SUCCESS,
      action: response,
    })
  } catch (error) {

    yield put({
      type: types.ADD_DOMAIN_ERROR,
      error: error,
    })
  }
}


function* handleDeleteDomain(action) {
  try {
    const response = yield call(removeWebsite, action.params)
    yield put({
      type: types.DELETE_DOMAIN_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.DELETE_DOMAIN_ERROR,
      error: error.response,
    })
  }
}


function* handleUpdateStatusDomain(action) {
  try {
    const response = yield call(updateStatusWebsite, action.params)
    yield put({
      type: types.UPDATE_STATUS_DOMAIN_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.UPDATE_STATUS_DOMAIN_ERROR,
      error: error.response,
    })
  }
}


function* handleGetDomainGuidScript(action) {
  try {
    const response = yield call(getDomainGuidScriptRequest, action.domainId)
    yield put({
      type: types.GET_DOMAIN_GUID_SCRIPT_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_DOMAIN_GUID_SCRIPT_ERROR,
      error: error.response,
    })
  }
}


function* handleUpdateDomainAddress(action) {
  try {
    const response = yield call(updateDomainAddress, action.params)
    yield put({
      type: types.UPDATE_DOMAIN_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.UPDATE_DOMAIN_ERROR,
      error: error.response,
    })
  }
}





function* watcherDomainSaga() {
  yield takeEvery(types.GET_DOMAIN_REQUEST, handleGetDomain)
  yield takeEvery(types.CHECK_DOMAIN_REQUEST, handleCheckDomain)
  yield takeEvery(types.DELETE_DOMAIN_REQUEST, handleDeleteDomain)
  yield takeEvery(types.ADD_DOMAIN_REQUEST, handleAddDomain)
  yield takeEvery(types.UPDATE_STATUS_DOMAIN_REQUEST, handleUpdateStatusDomain)
  yield takeEvery(types.GET_DOMAIN_GUID_SCRIPT_REQUEST, handleGetDomainGuidScript)
  yield takeEvery(types.UPDATE_DOMAIN_REQUEST, handleUpdateDomainAddress)


}

export default watcherDomainSaga
